import abis from "./NFTAbi.json";

export const NFTAddress = "0xbe7cf276b6e25cc677cb373121efe3a943e1bec7";
export const NFTAbis = abis;
